import React from "react";
import { Button, Modal } from "antd";
import { CloseOutlined, CheckCircleFilled } from "@ant-design/icons";
import CurrencyFormatter from "../../../components/CurrencyFormatter";
import "./OrderSuccessModal.css";
import { useTranslation } from "react-i18next";

const OrderSuccessModal = ({ visible, onClose, orderSummary }) => {
  const { t } = useTranslation("qr");
  if (!orderSummary) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      centered
      width={440}
      className="order-success-modal-minimal"
    >
      <div className="minimal-success-content">
        {/* Success Icon */}
        <div className="minimal-success-icon">
          <CheckCircleFilled />
        </div>

        {/* Success Message */}
        <h2 className="minimal-success-title">{t("order_confirmed")}</h2>

        {/* Order ID */}
        <div className="minimal-order-id">
          <span>
            {t("order_id")}: {orderSummary.orderId}
          </span>
        </div>

        {/* Divider */}
        <div className="minimal-divider"></div>

        {/* Order Items */}
        <div className="minimal-order-items">
          {orderSummary.items.map((item, index) => (
            <div key={index} className="minimal-item-row">
              <div className="minimal-item-info">
                <div className="minimal-item-name">
                  {item.name}
                  {item.tags && item.tags.length > 0 && (
                    <span className="minimal-item-options">
                      {item.tags.map((tag, idx) => (
                        <span key={idx}>
                          •{" "}
                          {typeof tag === "string"
                            ? tag
                            : tag.name_en || tag.name}
                        </span>
                      ))}
                    </span>
                  )}
                </div>
                <div className="minimal-item-qty">×{item.quantity}</div>
              </div>
              <div className="minimal-item-price">
                <CurrencyFormatter value={item.total} />
              </div>
            </div>
          ))}
        </div>

        {/* Total */}
        <div className="minimal-total-row">
          <span className="minimal-total-label">{t("total")}</span>
          <span className="minimal-total-amount">
            <CurrencyFormatter value={orderSummary.totalAmount} />
          </span>
        </div>

        {/* Action Button */}
        <Button type="primary" className="minimal-done-btn" onClick={onClose} htmlType="button">
          {t("done")}
        </Button>
      </div>
    </Modal>
  );
};

export default OrderSuccessModal;
